import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { UtilService, SERVICE_END_POINT, AnalyticsService, AuthService } from '../../../../shared';
import * as UserDataConfig from '../../config/user-data.config';
import { CurrencyFunctionalityService, DealPartnerFunctionalityService } from 'src/app/shared';
import * as StoreModel from '../../../../model/ngrx';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/state/app.state';
import * as YourPensionSavings from '../../../../store/actions/your-pension-savings.actions';
import { FormValidationsService } from '../../../../shared';
import { ApplicationDataCaptureService } from 'src/app/shared/services/api-services/application-datacapture.service';
import { QuoteDataCaptureService } from 'src/app/shared';
import { ContentTopNavComponent } from 'src/app/common-components';
import { quoteLevelConstants } from '../../../../shared/constants/attribute-values.constants';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { AlertModal } from 'src/app/model/alert';

import * as YourLumpSumActions from '../../../../store/actions/your-lump-sum-allowances.actions';

@Component({
  selector: 'app-your-pension-savings',
  templateUrl: './your-pension-savings.component.html',
  styleUrls: ['./your-pension-savings.component.scss']
})
export class YourPensionSavingsComponent implements OnInit {
  public userInputDetail = UserDataConfig.ElementsConfig;
  public ButtonConfig = UserDataConfig.ElementsConfig.buttonConfigPensionSaving;
  protected pensionProviderConfig = this.userInputDetail.pensionProviderConfig;
  protected radioButtonFundtransferType = this.userInputDetail.radioButtonFundtransferType;
  protected radioButtonFunddrawdown = this.userInputDetail.radioButtonFunddrawdown;
  private fundDetails: StoreModel.YourPension;
  private fundDetailsStore: Observable<StoreModel.YourPension[]>;
  public tooltipModalConfig: AlertModal;
  @ViewChild('topNavbar', { static: false }) topNavbarchild!: ContentTopNavComponent;
  editMode: boolean;
  showTaxfreeSlider: boolean;
  showTaxfreeInput: boolean;
  showTaxfreeSliderExt: boolean;
  showTaxfreeInputExt: boolean;
  addressSeachEnabled: boolean;
  overseasCustomer: boolean;
  noPensionAdded: boolean;
  noExtPensionAdded: boolean;
  // pensionSavingsForm: FormGroup;
  pensionSavingsExtForm: FormGroup;
  dynamicForm: FormGroup;
  accrdionList: any;
  accrdionListExt: any;
  totalIntroProvderFund: any;
  totalIntroProvderTaxfree: any;
  totalExtIntroProvderFund: any;
  totalExtIntroProvderTaxfree: any;
  taxfreePerc: any;
  percentageTaxFree: any;
  quoteFundInfo: any;
  responseApplicationData: any;
  pensionSavings: any;
  resultAddress: any[];
  introProvider;
  contentData;
  displayBeneficiaryDetails: boolean = false;
  resPensionSavingsStore: Observable<StoreModel.PensionSavings[]>;
  subscripSaveProgress: Subscription;
  subscriptn: Subscription;
  subscripLogout: Subscription;
  isDealPartnerWithoutProductCode: boolean;
  postcode;
  CMSData;
  screenName;
  resultQuote: any;
  resPensionSavings: any;
  warningTextDealPartner: string;
  showWarningDealPartner: boolean = false;
  showWarningExternal: boolean = false;
  warningTextExternal: string;
  productcodenotUsed = [];
  selectedProductCode = false;
  displayTooltipAlert = false;
  tooltipModal;
  externalProvidersList: any[];
  isMaturityQuote: boolean = false;
  legalAndGeneralProviderList: any[];
  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private utilService: UtilService,
    private store: Store<AppState>,
    private applicationDatacaptureService: ApplicationDataCaptureService,
    private router: Router,
    public el: ElementRef,
    private quoteDatacaptureService: QuoteDataCaptureService, private analyticsService: AnalyticsService,
    private authService: AuthService) {
    this.contentData = this.route.snapshot.data.contentData;
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;

    this.resPensionSavingsStore = store.select(STORE_VAL.pension_savings);
    store.select(STORE_VAL.application_data_response).subscribe((val) => {
      if (val && val.length > 0) {
        this.responseApplicationData = val[0];
        this.displayBeneficiaryDetails = val[0]['showBeneficiary'];
        this.quoteFundInfo = (this.responseApplicationData && this.responseApplicationData.quoteFundInfo
          && this.responseApplicationData.quoteFundInfo.length > 0)
          ? this.responseApplicationData.quoteFundInfo[0] : null;
        this.resPensionSavings = this.responseApplicationData.cedingPension[0];
        this.isMaturityQuote = val[0].maturityQuote;
        // if (this.responseApplicationData['appSignedInd']) {
        //   this.afterApplyDetail.buttonConfig.label = 'Back to my quotes';
        // }
      }
    });
    store.select(STORE_VAL.pension_savings).subscribe(res => {
      // const arrPension = res as Array<StoreModel.PensionSavings>;
      if (res && res.length > 0 && res[0].length >= 1) {
        this.pensionSavings = res[0];
        // console.log('this.pensionSavings');
        // console.log(this.pensionSavings);
      }
    });
    // this.quoteFundInfo = {
    //   cedingProvider: 'H',
    //   externalFundProvided: 'N',
    //   quoteRef: null,
    //   totalQuoteFund: 40000,
    //   totalTfc: 14,
    //   productType: 'C'
    // };
    store.select(STORE_VAL.quote_result).subscribe(res => {
      if (res.length > 0) {
        this.resultQuote = res[0];
      }
    });
    this.route.data
      .subscribe((data) => {
        this.CMSData = data.cmsJson;
      });
  }

  ngOnInit() {
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;

    this.isDealPartnerWithoutProductCode = DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(this.quoteFundInfo.cedingProvider);
    this.introProvider = this.userInputDetail.sourcesListCvt.filter(item => this.quoteFundInfo.cedingProvider === item.fundProvider);
    this.quoteDatacaptureService.searchPensionProviderByIntro('N').subscribe(extList => {
      this.externalProvidersList = extList;
      if (this.isMaturityQuote && this.introProvider && this.introProvider.length > 0 && this.introProvider[0].fundProvider === 'I') {
        this.quoteDatacaptureService.searchPensionProviderByIntro('L&G').subscribe(res => {
          this.legalAndGeneralProviderList = res && res.length > 0 ? res[0] : [];
          this.GetCMSDataServiceMapper();
        })
      } else {
        this.GetCMSDataServiceMapper();
      }
    });
  }

  initiliseForm() {
    this.dynamicForm = this.fb.group({
      pensionPot: new FormArray([]),
      extPensionPot: new FormArray([])
    });
    this.accrdionList = [];
    this.accrdionListExt = [];
    this.totalIntroProvderFund = '0.00';
    this.totalExtIntroProvderFund = '0.00';
    this.totalIntroProvderTaxfree = '0.00';
    this.totalExtIntroProvderTaxfree = '0.00';
    if (this.pensionSavings) {
      this.setFormValues();
    } else {
      this.addressSeachEnabled = true;
      this.overseasCustomer = false;
      if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes ||
        this.isGARProduct(this.resultQuote['garIndicator']) || this.isMaturityQuote) {
        this.onSave('dealpartner');

      }
    }
    this.subscripSaveProgress = this.applicationDatacaptureService.invokeSaveFunction.subscribe((res) => {
      this.saveProgressClick(res);
    });
    this.subscripLogout = this.applicationDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });

  }

  externalCheck() {
    const extPensionCheck = this.quoteFundInfo && (this.quoteFundInfo.cedingProvider === 'B' ||
      this.quoteFundInfo.externalFundProvided === 'Y' || this.isDealPartnerWithoutProductCode)
      && this.resultQuote.isGMP !== 'Y' && !this.isGARProduct(this.resultQuote.garIndicator)
    return extPensionCheck;
  }

  setFormValues = () => {
    this.pensionSavings.forEach((pension, index) => {
      if (pension && pension.address && pension.address.postcode) {
        this.postcode = pension.address.postcode.trim();
      } else {
        this.postcode = '';
      }
      let addressLine1 = pension && pension.address && pension.address.line1 ? pension.address.line1 : null;
      let addressLine2 = pension && pension.address && pension.address.line2 ? pension.address.line2 : null;
      let addressLine3 = pension && pension.address && pension.address.line3 ? pension.address.line3 : null;
      let addressLine4 = pension && pension.address && pension.address.line4 ? pension.address.line4 : null;
      if (pension.extTfcAmt != null && this.externalCheck()) {
        let providerName = this.applicationDatacaptureService.getUpdatedPensionProvider(this.externalProvidersList, pension);
        this.extPensionForm.push(this.fb.group({
          textpensionProvider: [providerName, Validators.required],
          textplanNumber: [pension.policyNo, Validators.required],
          rbtnfundtransfertype: [pension.fullFundInd, Validators.required],
          rbtnfunddrawdown: [pension.drawdownInd, Validators.required],
          cncyfundValue: [CurrencyFunctionalityService.convertNumberToCurrency(pension.fundValue),
          Validators.required],
          rbtntaxfreeToggle: [pension.taxfreeSelected, Validators.required],
          sldrtaxfreeSlider: [pension.extTfcPct],
          cncyfundValueTaxfree: [CurrencyFunctionalityService.convertNumberToCurrency(pension.extTfcAmt)],
          adrsaddressline1: [addressLine1, Validators.required],
          adrsaddressline2: [addressLine2],
          adrsaddressline3: [addressLine3],
          adrsaddressline4: [addressLine4],
          postcode: [this.postcode, Validators.required],
          isActive: false,
          optionCode: pension.optionCode,
          providerReference: pension.providerReference
        }));
        this.createUserConfig(this.extPensionForm, 'ext', pension, index);
        if ((this.extPensionForm.value.length == 1) && pension && pension.taxfreeSelected) {
          let tfcVal = { code: '' };
          tfcVal.code = pension.taxfreeSelected;
          this.checkWarning(tfcVal, 0, 'ext');
        }

      } else {
        let flag = ((this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes ||
          this.isGARProduct(this.resultQuote['garIndicator'])) &&
          this.pensionForm.length <= 1) ? true : false;
        if (flag) {
          this.pensionForm.removeAt(0);
          if (this.quoteFundInfo.totalTfc > 0) {
            this.utilService.refreshBreadcrumb({ hideLumpSumAllowance: false });
          } else {
            this.utilService.refreshBreadcrumb({ hideLumpSumAllowance: true });
          }

        }
        if (this.quoteFundInfo.cedingProvider === 'J') {
          this.pensionForm.push(this.fb.group({
            drdnpensionProvider: [null, Validators.required],
            // textpensionProvider: ['', Validators.required],
            textplanNumber: [pension.policyNo, Validators.required],
            codeproductCode: [pension.productCode, Validators.required],
            rbtnfundtransfertype: [pension.fullFundInd, Validators.required],
            rbtnfunddrawdown: [pension.drawdownInd, Validators.required],
            cncyfundValue: [CurrencyFunctionalityService.convertNumberToCurrency(pension.fundValue), Validators.required],
            rbtntaxfreeToggle: [pension.taxfreeSelected, Validators.required],
            sldrtaxfreeSlider: [pension.tfcPct],
            cncyfundValueTaxfree: [CurrencyFunctionalityService.convertNumberToCurrency(pension.tfcAmt)],
            adrsaddressline1: [addressLine1, Validators.required],
            adrsaddressline2: [addressLine2],
            adrsaddressline3: [addressLine3],
            adrsaddressline4: [addressLine4],
            postcode: [this.postcode, Validators.required],
            isActive: false,
            optionCode: pension.optionCode,
            providerReference: pension.providerReference
          }));
        } else if (this.legalAndGeneralProviderList && Object.keys(this.legalAndGeneralProviderList).length > 0) {
          this.pensionForm.push(this.fb.group({
            drdnpensionProvider: [this.legalAndGeneralProviderList['Name'], Validators.required],
            // textpensionProvider: ['', Validators.required],
            textplanNumber: [pension.policyNo, Validators.required],
            rbtnfundtransfertype: [pension.fullFundInd, Validators.required],
            rbtnfunddrawdown: [pension.drawdownInd, Validators.required],
            cncyfundValue: [CurrencyFunctionalityService.convertNumberToCurrency(pension.fundValue)],
            rbtntaxfreeToggle: [pension.taxfreeSelected],
            sldrtaxfreeSlider: [pension.tfcPct],
            cncyfundValueTaxfree: [CurrencyFunctionalityService.convertNumberToCurrency(pension.tfcAmt)],
            adrsaddressline1: [this.legalAndGeneralProviderList['Address 1'], Validators.required],
            adrsaddressline2: [this.legalAndGeneralProviderList['Address 2']],
            adrsaddressline3: [this.legalAndGeneralProviderList['Address 3']],
            adrsaddressline4: [this.legalAndGeneralProviderList['Address 4']],
            postcode: [this.legalAndGeneralProviderList['Post Code'], Validators.required],
            isActive: false,
            optionCode: pension.optionCode,
            providerReference: pension.providerReference
          }));
        } else {
          this.pensionForm.push(this.fb.group({
            drdnpensionProvider: [null, Validators.required],
            // textpensionProvider: ['', Validators.required],
            textplanNumber: [pension.policyNo, Validators.required],
            rbtnfundtransfertype: [pension.fullFundInd, Validators.required],
            rbtnfunddrawdown: [pension.drawdownInd, Validators.required],
            cncyfundValue: [CurrencyFunctionalityService.convertNumberToCurrency(pension.fundValue), Validators.required],
            rbtntaxfreeToggle: [pension.taxfreeSelected, Validators.required],
            sldrtaxfreeSlider: [pension.tfcPct],
            cncyfundValueTaxfree: [CurrencyFunctionalityService.convertNumberToCurrency(pension.tfcAmt)],
            adrsaddressline1: [addressLine1, Validators.required],
            adrsaddressline2: [addressLine2],
            adrsaddressline3: [addressLine3],
            adrsaddressline4: [addressLine4],
            postcode: [this.postcode, Validators.required],
            isActive: false,
            optionCode: pension.optionCode,
            providerReference: pension.providerReference
          }));
        }
        if (flag) {
          this.clearValidatorsForGARGMP(this.pensionForm, index, flag);
        }



        // this.pensionForm.controls.pus(this.fb.control('test', [null, Validators.required]))
        this.createUserConfig(this.pensionForm, null, pension, index);
        if ((this.pensionForm.value.length == 1) && pension && pension.taxfreeSelected) {
          let tfcVal = { code: '' };
          tfcVal.code = pension.taxfreeSelected;
          this.checkWarning(tfcVal, 0);
        }

      }
      if (this.responseApplicationData.deathInService) {
        this.clearDISTFCValidation(this.pensionForm, index);
      }
    });
  }
  clearValidatorsForGARGMP(pensionForm, index: number, isGARGMP?: boolean) {
    if (isGARGMP) {
      const form = pensionForm.controls[index] as FormArray;
      form.get('cncyfundValue').setValidators(null);
      form.get('rbtntaxfreeToggle').setValidators(null);
    }
  }

  clearDISTFCValidation(pensionForm, index: number) {
    const form = pensionForm.controls[index] as FormArray;
    //  form.get('cncyfundValue').setValidators(null);
    //  form.get('rbtntaxfreeToggle').setValidators(null);
    //   form.updateValueAndValidity()

  }
  // convenience getters for easy access to form fields
  get f() { return this.dynamicForm.controls; }
  get pensionForm() { return this.f.pensionPot as FormArray; }
  get extPensionForm() { return this.f.extPensionPot as FormArray; }

  OnBackClick() {
    // this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
    // this.store.dispatch(new PersDetailsActions.AddPersonalDetails(this.annuitantDetailForm.value));
    if (!this.checkErrorinForm()) {
      const inputData = this.processPayload(this.pensionForm, this.extPensionForm);
      this.saveFormValues(inputData);
      this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
        this.utilService.navigatetopreviouspage();
        //this.router.navigate(['apply/your-payment-details']);
      });
    }
  }
  saveProgressClick(value = '') {
    if (!this.checkErrorinForm()) {
      const inputData = this.processPayload(this.pensionForm, this.extPensionForm);
      this.saveFormValues(inputData);
      this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
        this.topNavbarchild.displayAlert = true;
        this.topNavbarchild.setAlertatSavecomponent();
        if (value === 'yoursavedquote') {
          this.router.navigate(['quote/your-saved-quotes']);
        } else if (value === 'updatemyDetail') {
          this.router.navigate(['home/update-my-details']);
        }

      });
    }
  }
  checkErrorinForm(): boolean {
    let returnerror = false;
    this.pensionForm.controls.forEach((element: FormGroup) => {
      const invalidDataObj = FormValidationsService.isInvalidDataFoundInForm(element);
      if (invalidDataObj && invalidDataObj.invalidDataPresent) {
        this.scrollInvalidForm();
        returnerror = true;
        return;
      }
    });
    this.extPensionForm.controls.forEach((element: FormGroup) => {
      const invalidDataObj = FormValidationsService.isInvalidDataFoundInForm(element);
      if (invalidDataObj && invalidDataObj.invalidDataPresent) {
        this.scrollInvalidForm();
        returnerror = true;
        return;
      }
    });
    return returnerror;
  }


  toggleContainer = (data) => {
    //console.log(data);
  }
  currencyChangeHandler(val, index, mode?: string) {
    if (mode && mode === 'ext') {
      const accrdionListExt = this.accrdionListExt[index];
      const form = this.extPensionForm.controls[index] as FormArray;
      accrdionListExt.sldrtaxfreeSlider.unselectedByDefault = true;
      accrdionListExt.sldrtaxfreeSlider.visible = false;
      accrdionListExt.sldrtaxfreeSlider.fundAmount =
        CurrencyFunctionalityService.convertCurrencyToNumber(val);
      accrdionListExt.cncyfundValueTaxfree.visible = false;
      if (this.pensionSavings) {
        const taxfreeToggle = form.get('rbtntaxfreeToggle').value;
        if (taxfreeToggle === 'P') {
          accrdionListExt.sldrtaxfreeSlider.unselectedByDefault = false;
          accrdionListExt.sldrtaxfreeSlider.visible = true;
        } else if (taxfreeToggle === 'C') {
          accrdionListExt.cncyfundValueTaxfree.visible = true;
        }
      } else {
        form.get('rbtntaxfreeToggle').setValue(null);
        form.get('sldrtaxfreeSlider').setValue(null);
        form.get('cncyfundValueTaxfree').setValue(null);
      }
      let updatedObj;
      if (!val || val === '0') {
        updatedObj = {
          ...accrdionListExt.rbtntaxfreeToggle,
          questionOptions: [
            {
              label: 'None',
              code: 'N',
              disable: true
            },
            {
              label: '%',
              code: 'P',
              disable: true
            },
            {
              label: '£',
              code: 'C',
              disable: true
            }
          ]
        };
      } else {
        // make new object of updated object.
        updatedObj = {
          ...accrdionListExt.rbtntaxfreeToggle,
          questionOptions: [
            {
              label: 'None',
              code: 'N',
              disable: false
            },
            {
              label: '%',
              code: 'P',
              disable: false
            },
            {
              label: '£',
              code: 'C',
              disable: false
            }
          ]
        };
      }
      accrdionListExt.rbtntaxfreeToggle = updatedObj;
      this.calculateTotalFund('ext');
      if (this.pensionSavings) {
        this.calculateTaxfreeTotal('ext');
      }
    } else {
      const accodionList = this.accrdionList[index];
      const form = this.pensionForm.controls[index] as FormArray;
      accodionList.sldrtaxfreeSlider.unselectedByDefault = true;
      accodionList.sldrtaxfreeSlider.visible = false;
      accodionList.sldrtaxfreeSlider.fundAmount =
        CurrencyFunctionalityService.convertCurrencyToNumber(val);
      if (accodionList && accodionList['cncyfundValueTaxfree']) {
        accodionList.cncyfundValueTaxfree.visible = false;
      }

      if (this.pensionSavings) {
        const taxfreeToggle = form.get('rbtntaxfreeToggle').value;
        if (taxfreeToggle === 'P') {
          accodionList.sldrtaxfreeSlider.unselectedByDefault = false;
          accodionList.sldrtaxfreeSlider.visible = true;
        } else if (taxfreeToggle === 'C') {
          accodionList.cncyfundValueTaxfree.visible = true;
        }
      } else {
        form.get('rbtntaxfreeToggle').setValue(null);
        form.get('sldrtaxfreeSlider').setValue(null);
        form.get('cncyfundValueTaxfree').setValue(null);
      }
      let updatedObj;
      if (!val || val === '0') {
        updatedObj = {
          ...accodionList.rbtntaxfreeToggle,
          questionOptions: [
            {
              label: 'None',
              code: 'N',
              disable: true
            },
            {
              label: '%',
              code: 'P',
              disable: true
            },
            {
              label: '£',
              code: 'C',
              disable: true
            }
          ]
        };
      } else {
        // make new object of updated object.
        updatedObj = {
          ...accodionList.rbtntaxfreeToggle,
          questionOptions: [
            {
              label: 'None',
              code: 'N',
              disable: false
            },
            {
              label: '%',
              code: 'P',
              disable: false
            },
            {
              label: '£',
              code: 'C',
              disable: false
            }
          ]
        };
      }
      accodionList.rbtntaxfreeToggle = updatedObj;
      this.calculateTotalFund();
      if (this.pensionSavings) {
        this.calculateTaxfreeTotal();
      }
    }
    this.utilService.refreshToggleButton();
  }
  changeScrollParams(value, index, mode?: string) {
    if (value) {
      if (value.controlName) {
        const val = (mode && mode === 'ext') ? this.accrdionListExt[index].cncyfundValue.value :
          this.accrdionList[index].cncyfundValue.value;
        // this.quoteForm.setValidators(this.customValidator());
        value.unselectedByDefault = false;
        this.utilService.refreshSliderWithValue(
          CurrencyFunctionalityService.convertCurrencyToNumber(val));
        if (mode && mode === 'ext') {
          this.calculateTaxfreeTotal('ext');
        } else {
          this.calculateTaxfreeTotal();
        }
      }
    }
  }
  taxfreeChangeHandler = (val, index, control?: string) => {
    let fundValue;
    if (control && control === 'ext') {
      fundValue = CurrencyFunctionalityService.convertCurrencyToNumber(
        this.accrdionListExt[index].cncyfundValue.value);
      val = parseFloat(val.replace(/,/g, ''));
      this.taxfreePerc = (val * 100) / fundValue;
      this.accrdionListExt[index].cncyfundValueTaxfree.titleValue = this.taxfreePerc.toFixed(2).toString();
      this.calculateTaxfreeTotal('ext');
    } else {
      fundValue = CurrencyFunctionalityService.convertCurrencyToNumber(
        this.accrdionList[index].cncyfundValue.value);
      val = parseFloat(val.replace(/,/g, ''));
      this.taxfreePerc = (val * 100) / fundValue;
      this.accrdionList[index].cncyfundValueTaxfree.titleValue = this.taxfreePerc.toFixed(2).toString();
      this.calculateTaxfreeTotal();
    }
  }

  PercentagetaxfreeChangeHandler = (value, index, control?: string) => {
    let fundValue;
    if (control && control === 'ext') {
      value.unselectedByDefault = false;
      this.calculateTaxfreeTotal('ext');
    } else {
      value.unselectedByDefault = false;
      this.calculateTaxfreeTotal();
    }
  }
  toggleSlider = (data, index, control) => {

    if (control && control === 'ext') {
      this.checkWarning(data, index, 'ext');
      this.accrdionListExt[index].sldrtaxfreeSlider.visible = false;
      this.accrdionListExt[index].cncyfundValueTaxfree.visible = false;
      if (data.code === 'P') {
        this.accrdionListExt[index].sldrtaxfreeSlider.visible = true;
      } else if (data.code === 'C') {
        this.accrdionListExt[index].cncyfundValueTaxfree.visible = true;
      }
      this.calculateTaxfreeTotal('ext');
    } else {
      this.checkWarning(data, index);
      this.accrdionList[index].sldrtaxfreeSlider.visible = false;
      this.accrdionList[index].cncyfundValueTaxfree.visible = false;
      if (data.code === 'P') {
        this.accrdionList[index].sldrtaxfreeSlider.visible = true;
      } else if (data.code === 'C') {
        this.accrdionList[index].cncyfundValueTaxfree.visible = true;
      }
      this.calculateTaxfreeTotal();
    }
  }

  getExternalProviderName = (providerName: string) => {
    switch (providerName) {
      case 'L':
        return 'PensionBee';
      case 'M':
        return 'Aon';
      default: return "";
    }
  }
  checkWarning = (val, i, mode?: string) => {

    if (mode && mode === 'ext') {
      if (i == 0 && this.quoteFundInfo && ((this.quoteFundInfo.cedingProvider && this.quoteFundInfo.cedingProvider === 'B') || this.quoteFundInfo.externalFundProvided === 'Y' || this.isDealPartnerWithoutProductCode)) {
        if (this.quoteFundInfo.cedingProvider === 'L' || this.quoteFundInfo.cedingProvider === 'M') {
          // //console.log(this.getExternalProviderName(this.quoteFundInfo.cedingProvider));
          if (this.quoteFundInfo.totalTfc !== 0 && val.code === 'N') {
            this.showWarningExternal = true;
            this.warningTextExternal = this.contentData.yourPensionSavings.tfcIncludedMessage1 + ' ' + this.getExternalProviderName(this.quoteFundInfo.cedingProvider) + this.contentData.yourPensionSavings.tfcIncludedMessage2;
          } else if ((this.quoteFundInfo.totalTfc === 0 || this.quoteFundInfo.totalTfc === null) && val.code !== 'N') {
            this.showWarningExternal = true;
            this.warningTextExternal = this.contentData.yourPensionSavings.tfcNotIncludedMessage1 + ' ' + this.getExternalProviderName(this.quoteFundInfo.cedingProvider) + this.contentData.yourPensionSavings.tfcNotIncludedMessage2;
            //this.warningTextDealPartner = this.contentData.yourPensionSavings.extTfcNotIncludedMessage;
          } else {
            this.showWarningExternal = false;
          }
        } else {
          if (this.quoteFundInfo.externalTFC !== 0 && val.code === 'N') {
            this.showWarningExternal = true;
            this.warningTextExternal = this.contentData.yourPensionSavings.extTfcIncludedMessage;
          } else if ((this.quoteFundInfo.externalTFC === 0 || this.quoteFundInfo.externalTFC === null) && val.code !== 'N') {
            this.showWarningExternal = true;
            this.warningTextExternal = this.contentData.yourPensionSavings.extTfcNotIncludedMessage;
          } else {
            this.showWarningExternal = false;
          }
        }

      }
    }
    else {
      if (i == 0 && this.quoteFundInfo && (this.quoteFundInfo.cedingProvider && this.quoteFundInfo.cedingProvider !== 'B')) {
        if (this.quoteFundInfo.totalTfc !== 0 && val.code === 'N') {
          this.showWarningDealPartner = true;
          this.warningTextDealPartner = this.contentData.yourPensionSavings.tfcIncludedMessage1 + ' ' + this.gettingCedingProvider() + this.contentData.yourPensionSavings.tfcIncludedMessage2;
        } else if ((this.quoteFundInfo.totalTfc === 0 || this.quoteFundInfo.totalTfc === null) && val.code !== 'N') {
          this.showWarningDealPartner = true;
          this.warningTextDealPartner = this.contentData.yourPensionSavings.tfcNotIncludedMessage1 + ' ' + this.gettingCedingProvider() + this.contentData.yourPensionSavings.tfcNotIncludedMessage2;
        } else {
          this.showWarningDealPartner = false;
        }
      }
    }
  }

  calculateTotalFund = (mode?: string) => {
    if (mode && mode === 'ext') {
      this.totalExtIntroProvderFund = this.accrdionListExt.map(accrdn =>
        CurrencyFunctionalityService.convertCurrencyToNumber(accrdn.cncyfundValue.value))
        .reduce((prev, next) => {
          return CurrencyFunctionalityService.convertCurrencyToNumber(prev) +
            CurrencyFunctionalityService.convertCurrencyToNumber(next);
        });
      this.totalExtIntroProvderFund = this.totalExtIntroProvderFund ? CurrencyFunctionalityService.getNumberWithoutRoundOff(this.totalExtIntroProvderFund, 2) : '0.00';
      // this.totalExtIntroProvderFund ? CurrencyFunctionalityService.convertNumberToCurrency(this.totalExtIntroProvderFund) : '0.00'

    } else {
      this.totalIntroProvderFund = this.accrdionList.map(accrdn =>
        CurrencyFunctionalityService.convertCurrencyToNumber(accrdn.cncyfundValue.value))
        .reduce((prev, next) => {
          return CurrencyFunctionalityService.convertCurrencyToNumber(prev) +
            CurrencyFunctionalityService.convertCurrencyToNumber(next);
        });
      this.totalIntroProvderFund = this.totalIntroProvderFund ? this.totalIntroProvderFund : '0.00';

    }
  }
  calculateTaxfreeTotal = (mode?: string) => {
    let totalTaxfree = 0;
    if (mode && mode === 'ext') {
      for (const control of this.extPensionForm.controls) {
        let taxFreeAmount;
        switch (control.value.rbtntaxfreeToggle) {
          case 'P':
            taxFreeAmount = (CurrencyFunctionalityService.convertCurrencyToNumber(
              control.value.cncyfundValue) * control.value.sldrtaxfreeSlider) / 100;
            totalTaxfree = totalTaxfree + taxFreeAmount;
            break;
          case 'C':
            // tslint:disable-next-line:max-line-length
            taxFreeAmount = CurrencyFunctionalityService.convertNumberToCurrency(
              control.value.cncyfundValueTaxfree);
            totalTaxfree = totalTaxfree + (control.value.cncyfundValueTaxfree ? parseFloat(
              control.value.cncyfundValueTaxfree.replace(',', '')) : 0.00);
            break;
          default:
            break;
        }
      }
      // this.totalExtIntroProvderTaxfree = totalTaxfree ? CurrencyFunctionalityService.convertNumberToCurrency(totalTaxfree) : '0.00';
      this.totalExtIntroProvderTaxfree = totalTaxfree ? CurrencyFunctionalityService.getNumberWithoutRoundOff(totalTaxfree, 2) : '0.00';

    } else {

      for (const control of this.pensionForm.controls) {
        let taxFreeAmount;
        switch (control.value.rbtntaxfreeToggle) {
          case 'P':
            taxFreeAmount = (CurrencyFunctionalityService.convertCurrencyToNumber(
              control.value.cncyfundValue) * control.value.sldrtaxfreeSlider) / 100;
            totalTaxfree = totalTaxfree + taxFreeAmount;
            // accrdn.taxFreeAmount = CurrencyFunctionalityService.convertNumberToCurrency
            //   ((CurrencyFunctionalityService.convertCurrencyToNumber(accrdn.fundValue) * accrdn.taxfreeSlider) / 100);
            // accrdn.taxFreePercentage = accrdn.taxfreeSlider;
            break;
          case 'C':
            // tslint:disable-next-line:max-line-length
            taxFreeAmount = CurrencyFunctionalityService.convertNumberToCurrency(
              control.value.cncyfundValueTaxfree);
            totalTaxfree = totalTaxfree + (control.value.cncyfundValueTaxfree ?
              CurrencyFunctionalityService.convertCurrencyToNumber(control.value.cncyfundValueTaxfree) : 0.00);
            // tslint:disable-next-line:max-line-length
            // accrdn.taxFreePercentage = (CurrencyFunctionalityService.convertCurrencyToNumber(accrdn.taxFreeAmount) * 100) / CurrencyFunctionalityService.convertCurrencyToNumber(accrdn.fundValue);
            break;
          default:
            break;
        }
      }
      // this.totalIntroProvderTaxfree = totalTaxfree ? CurrencyFunctionalityService.convertNumberToCurrency(totalTaxfree) : '0.00';
      this.totalIntroProvderTaxfree = totalTaxfree ? CurrencyFunctionalityService.getNumberWithoutRoundOff(totalTaxfree, 2) : '0.00';
    }

    setTimeout(() => {
      if (((this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes ||
        this.isGARProduct(this.resultQuote['garIndicator']))) && this.quoteFundInfo.totalTfc > 0) {
        this.utilService.refreshBreadcrumb({ hideLumpSumAllowance: false });
      } else if (this.totalIntroProvderTaxfree == 0 && this.totalExtIntroProvderTaxfree == 0) {
        this.utilService.refreshBreadcrumb({ hideLumpSumAllowance: true });
      } else {
        this.utilService.refreshBreadcrumb({ hideLumpSumAllowance: false });
      }
    }, 1000)

  }
  gotoNext = () => {
    this.customValidation();
    if ((this.pensionForm.valid && this.extPensionForm.valid) ||
      ((this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes ||
        this.isGARProduct(this.resultQuote['garIndicator'])) && this.pensionForm.valid)) {
      if (this.checkPensionSavings()) {
        // const pensionPayload = this.accrdionList.concat(this.accrdionListExt);
        const inputData = this.processPayload(this.pensionForm, this.extPensionForm);
        this.saveFormValues(inputData);
        // if(this.totalIntroProvderTaxfree == 0 &&  this.totalExtIntroProvderTaxfree == 0) {
        //   this.store.dispatch(new YourLumpSumActions.RemoveYourLumpSumAllowances(0));
        // }
        this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
          //console.log('Response from backend', res);
          // this.dependantHealthRecordsForm.reset();
          if (((this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes ||
            this.isGARProduct(this.resultQuote['garIndicator']))) && this.quoteFundInfo.totalTfc > 0) {
            this.router.navigate(['/apply/your-lump-sum-allowances']);
          } else if (this.totalIntroProvderTaxfree == 0 && this.totalExtIntroProvderTaxfree == 0 && res.showBeneficiary) {
            this.router.navigate(['apply/your-beneficiary-details']);
            this.store.dispatch(new YourLumpSumActions.RemoveYourLumpSumAllowances(0));
          } else if (this.totalIntroProvderTaxfree > 0 || this.totalExtIntroProvderTaxfree > 0) {
            this.router.navigate(['/apply/your-lump-sum-allowances']);
          }
         /* if (res.showBeneficiary) {
            this.router.navigate(['apply/your-beneficiary-details']);
          }*/ else {
            this.router.navigate(['/apply/your-payment-details']);
          }


        });
      } else {
        setTimeout(() => {
          this.scrollInvalidForm();
        }, 0);
      }
    } else {
      //console.log('Not Valid', this.pensionForm.controls[0]);
      let index = 0;
      if (!this.pensionForm.valid) {
        for (const control of this.pensionForm.controls) {
          if (!control.valid) {
            this.accrdionList[index].isActive = true;
            const pensionForm = control as FormGroup;
            FormValidationsService.validateAllFormFields(pensionForm, this.analyticsService);
            break;
          } else {
            index++;
          }
        }
      } else if (!this.extPensionForm.valid) {
        for (const control of this.extPensionForm.controls) {
          if (!control.valid) {
            this.accrdionListExt[index].isActive = true;
            const pensionForm = control as FormGroup;
            FormValidationsService.validateAllFormFields(pensionForm, this.analyticsService);
            break;
          } else {
            index++;
          }
        }
      }

      setTimeout(() => {
        this.scrollInvalidForm();
      }, 0);
    }
  }
  saveProgress() {
    // Onclick of Save Progress button logic
    const inputData = this.processPayload(this.pensionForm, this.extPensionForm);
    this.saveFormValues(inputData);
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe();
  }
  saveAfterLogout() {
    // Onclick of Logout button logic
    const inputData = this.processPayload(this.pensionForm, this.extPensionForm);
    this.saveFormValues(inputData);
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveFormValues(pensionPayload) {
    this.store.dispatch(new YourPensionSavings.RemovePensionSavings(0));
    this.store.dispatch(new YourPensionSavings.AddPensionSavings(pensionPayload));
  }
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    // OnDestroy unsubscribing the subcriptions
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
  }
  processPayload(pensionPayload, extPensionPayload) {
    let dataformatted = [];
    pensionPayload.value.forEach((pension, index) => {
      let data = null;
      data = {
        fundValue: this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes ||
          this.isGARProduct(this.resultQuote['garIndicator']) || this.isMaturityQuote ?
          this.quoteFundInfo['totalQuoteFund'] : CurrencyFunctionalityService.convertCurrencyToNumber(pension.cncyfundValue),
        tfcAmt: this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes ||
          this.isGARProduct(this.resultQuote['garIndicator']) ?
          this.quoteFundInfo['totalTfc'] : CurrencyFunctionalityService.convertCurrencyToNumber(this.formatTaxfree(index).replace('£', '')),
        tfcPct: this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes ||
          this.isGARProduct(this.resultQuote['garIndicator']) ?
          this.resultQuote['taxFreeCashAmountPercent'] : this.getTaxfreePerc(pension),
        extTfcAmt: null,
        extTfcPct: null,
        fullFundInd: pension.rbtnfundtransfertype,
        drawdownInd: this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes ||
          this.isGARProduct(this.resultQuote['garIndicator']) ?
          quoteLevelConstants.radioToggleYesNo.no : pension.rbtnfunddrawdown,
        pensionProvider: this.accrdionList[index] ? this.accrdionList[index].drdnpensionProvider.value : null,
        address: {
          line1: pension.adrsaddressline1,
          line2: pension.adrsaddressline2,
          line3: pension.adrsaddressline3,
          line4: pension.adrsaddressline4,
          postcode: (pension && pension.postcode) ? pension.postcode.trim() : '',
          countryCode: null
        },
        policyNo: pension.textplanNumber,
        productCode: pension.codeproductCode,
        isCeding: true,
        taxfreeSelected: pension.rbtntaxfreeToggle,
        optionCode: this.accrdionList[index] && this.accrdionList[index].optionCode ? this.accrdionList[index].optionCode : null,
        providerReference: this.accrdionList[index] && this.accrdionList[index].providerReference ? this.accrdionList[index].providerReference : null,
      };
      if ((this.resultQuote['isGMP'] && this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes) ||
        (this.resultQuote['garIndicator'] && this.isGARProduct(this.resultQuote['garIndicator']))) {
        data['productCode'] = this.resPensionSavings.productCode ? this.resPensionSavings.productCode : '';
      }
      dataformatted.push(data);
    });
    extPensionPayload.value.forEach((pension, index) => {
      let data = null;
      data = {
        fundValue: CurrencyFunctionalityService.convertCurrencyToNumber(pension.cncyfundValue),
        tfcAmt: null,
        tfcPct: null,
        extTfcAmt: CurrencyFunctionalityService.convertCurrencyToNumber(this.formatTaxfree(index, 'ext').replace('£', '')),
        extTfcPct: this.getTaxfreePerc(pension),
        fullFundInd: pension.rbtnfundtransfertype,
        drawdownInd: pension.rbtnfunddrawdown,
        pensionProvider: pension.textpensionProvider,
        address: {
          line1: pension.adrsaddressline1,
          line2: pension.adrsaddressline2,
          line3: pension.adrsaddressline3,
          line4: pension.adrsaddressline4,
          postcode: (pension && pension.postcode) ? pension.postcode.trim() : '',
          countryCode: null
        },
        policyNo: pension.textplanNumber,
        isCeding: false,
        taxfreeSelected: pension.rbtntaxfreeToggle,
        optionCode: this.accrdionListExt[index].optionCode ? this.accrdionListExt[index].optionCode : null,
        providerReference: this.accrdionListExt[index].providerReference ? this.accrdionListExt[index].providerReference : null
      };
      dataformatted.push(data);
    });
    return dataformatted;
  }
  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }
  removePensionSavings(index, mode?: string) {
    if (mode === 'ext') {
      this.accrdionListExt.splice(index, 1);
      if (this.accrdionListExt && this.accrdionListExt.length > 0) {
        this.calculateTotalFund('ext');
        this.calculateTaxfreeTotal('ext');
      }
    } else {
      this.accrdionList.splice(index, 1);
      if (this.accrdionList && this.accrdionList.length > 0) {
        this.calculateTotalFund();
        this.calculateTaxfreeTotal();
      }
    }
  }
  customValidation = (mode?: string) => {
    let i = 0;
    for (const control of this.pensionForm.controls) {
      const form = control as FormGroup;
      const taxfreeToggle = form.controls['rbtntaxfreeToggle'];
      const fundValueTaxfree = form.controls['cncyfundValueTaxfree'];
      const fundValue = form.controls['cncyfundValue'];
      const fundtransfertype = form.controls['rbtnfundtransfertype'];
      const funddrawdown = form.controls['rbtnfunddrawdown'];
      const percentageTaxFreeCash = form.controls['sldrtaxfreeSlider'];

      if (this.responseApplicationData.ptfc) {
        if (percentageTaxFreeCash && Number(percentageTaxFreeCash.value) < 0) {
          form.controls['sldrtaxfreeSlider'].setErrors({ notValid: true });
        } else {
          form.controls['sldrtaxfreeSlider'].setErrors(null);
        }
      } else {
        if (this.accrdionList && this.accrdionList[i] && this.accrdionList[i].sldrtaxfreeSlider.unselectedByDefault
          && taxfreeToggle.value === 'P') {
          form.controls['sldrtaxfreeSlider'].setErrors({ notValid: true });
        } else {
          form.controls['sldrtaxfreeSlider'].setErrors(null);
        }
      }


      if (taxfreeToggle.value === 'C' && !fundValueTaxfree.value) {
        fundValueTaxfree.setErrors({ required: true });
      } else {
        fundValueTaxfree.setErrors(null);
      }
      if (taxfreeToggle.value === 'C') {
        if (!fundValueTaxfree.value) {
          fundValueTaxfree.setErrors({ required: true });
        } else {
          const taxfreePerc = (CurrencyFunctionalityService.convertCurrencyToNumber(fundValueTaxfree.value) * 100) /
            CurrencyFunctionalityService.convertCurrencyToNumber(fundValue.value);
          if (this.responseApplicationData.ptfc) {
            if (taxfreePerc && taxfreePerc > 99.99) {
              fundValueTaxfree.setErrors({ invalidPTFCTaxfree: true });
            } else {
              fundValueTaxfree.setErrors(null);
            }

          } else if (taxfreePerc && taxfreePerc > 25) {
            fundValueTaxfree.setErrors({ invalidTaxfree: true });
          } else {
            fundValueTaxfree.setErrors(null);
          }
        }
      }
      if (fundtransfertype.value && this.quoteFundInfo['productType'] && this.quoteFundInfo['productType'] != 'C' && fundtransfertype.value === 'P' && funddrawdown.value === 'Y') {
        fundtransfertype.setErrors({ inValidTransferType: true });
      } else if (fundtransfertype.value && fundtransfertype.value !== '') {
        fundtransfertype.setErrors(null);
      } else {
        fundtransfertype.setErrors({ required: true });
      }
      if (this.responseApplicationData.deathInService) {
        taxfreeToggle.setErrors(null);
      } else if ((this.resultQuote['isGMP'] &&
        this.resultQuote['isGMP'] !== quoteLevelConstants.radioToggleYesNo.yes) &&
        !this.isGARProduct(this.resultQuote['garIndicator']) && !this.isMaturityQuote) {
        if (taxfreeToggle.value === null && fundValue.value !== '') {
          taxfreeToggle.setErrors({ required: true });
        } else {
          if (taxfreeToggle.value && taxfreeToggle.value !== 'N' && funddrawdown.value === 'Y') {
            taxfreeToggle.setErrors({ invalidTaxfree: true });
          } else {
            taxfreeToggle.setErrors(null);
          }
        }
      }
      i++;
    }
    let j = 0;
    for (const control of this.extPensionForm.controls) {
      const form = control as FormGroup;
      const taxfreeToggle = form.controls['rbtntaxfreeToggle'];
      const fundValueTaxfree = form.controls['cncyfundValueTaxfree'];
      const fundValue = form.controls['cncyfundValue'];
      const fundtransfertype = form.controls['rbtnfundtransfertype'];
      const funddrawdown = form.controls['rbtnfunddrawdown'];
      const percentageTaxFreeCash = form.controls['sldrtaxfreeSlider'];

      if (this.responseApplicationData.ptfc) {
        if (percentageTaxFreeCash && Number(percentageTaxFreeCash.value) < 0) {
          form.controls['sldrtaxfreeSlider'].setErrors({ notValid: true });
        } else {
          form.controls['sldrtaxfreeSlider'].setErrors(null);
        }
      } else {
        if (this.accrdionListExt[j].sldrtaxfreeSlider.unselectedByDefault
          && taxfreeToggle.value === 'P') {
          form.controls['sldrtaxfreeSlider'].setErrors({ notValid: true });
        } else {
          form.controls['sldrtaxfreeSlider'].setErrors(null);
        }
      }

      if (taxfreeToggle.value === 'C' && !fundValueTaxfree.value) {
        fundValueTaxfree.setErrors({ required: true });
      } else {
        fundValueTaxfree.setErrors(null);
      }
      if (taxfreeToggle.value === 'C') {
        if (!fundValueTaxfree.value) {
          fundValueTaxfree.setErrors({ required: true });
        } else {
          const taxfreePerc = (CurrencyFunctionalityService.convertCurrencyToNumber(fundValueTaxfree.value) * 100) /
            CurrencyFunctionalityService.convertCurrencyToNumber(fundValue.value);
          if (this.responseApplicationData.ptfc) {
            if (taxfreePerc && taxfreePerc > 99.99) {
              fundValueTaxfree.setErrors({ invalidPTFCTaxfree: true });
            } else {
              fundValueTaxfree.setErrors(null);
            }

          } else if (taxfreePerc && taxfreePerc > 25) {
            fundValueTaxfree.setErrors({ invalidTaxfree: true });
          } else {
            fundValueTaxfree.setErrors(null);
          }
        }
      }
      if (fundtransfertype.value && this.quoteFundInfo['productType'] && this.quoteFundInfo['productType'] != 'C' && fundtransfertype.value === 'P' && funddrawdown.value === 'Y') {
        fundtransfertype.setErrors({ inValidTransferType: true });
      } else if (fundtransfertype.value && fundtransfertype.value !== '') {
        fundtransfertype.setErrors(null);
      } else {
        fundtransfertype.setErrors({ required: true });
      }
      if (this.responseApplicationData.deathInService) {
        taxfreeToggle.setErrors(null);
      } else if (taxfreeToggle.value === null && fundValue.value !== '') {
        taxfreeToggle.setErrors({ required: true });
      } else {
        if (taxfreeToggle.value && taxfreeToggle.value !== 'N' && funddrawdown.value === 'Y') {
          taxfreeToggle.setErrors({ invalidTaxfree: true });
        } else {
          taxfreeToggle.setErrors(null);
        }
      }
      j++;
    }
  }
  checkPensionSavings = (): boolean => {
    let valid = true;
    this.noPensionAdded = false;
    this.noExtPensionAdded = false;
    if (((DealPartnerFunctionalityService.isDealPartner(this.quoteFundInfo.cedingProvider) && !this.isDealPartnerWithoutProductCode)
      || this.quoteFundInfo.cedingProvider === 'I') && this.accrdionList.length <= 0) {
      valid = false;
      this.noPensionAdded = true;
    } else if (valid && this.quoteFundInfo &&
      (this.quoteFundInfo.externalFundProvided === 'Y' || this.isDealPartnerWithoutProductCode)
      && this.accrdionListExt.length <= 0 && this.resultQuote['isGMP'] !== quoteLevelConstants.radioToggleYesNo.yes &&
      !this.isGARProduct(this.resultQuote['garIndicator'])) {
      valid = false;
      this.noExtPensionAdded = true;
    }
    if (this.quoteFundInfo.cedingProvider === 'J' && this.quoteFundInfo.productcode.length > 0) {
      let allProductCode = [...this.quoteFundInfo.productcode]
      this.pensionForm.controls.forEach((control, i) => {
        const index = allProductCode.indexOf(control['controls'].codeproductCode.value);
        if (index > -1) {
          allProductCode.splice(index, 1);
        }
      });
      this.productcodenotUsed = allProductCode;
      valid = !(this.productcodenotUsed.length > 0);
    }


    if (this.productcodenotUsed.length > 0) {
      const invalidElements = this.el.nativeElement.querySelector("#ProductDescription");
      if (invalidElements) {
        invalidElements.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      }
    }

    //console.log(valid);
    return valid;
  }

  isGARProduct(garIndicator: string) {
    if (garIndicator === quoteLevelConstants.garIndicators.yes || garIndicator === quoteLevelConstants.garIndicators.ignored
      || garIndicator === quoteLevelConstants.garIndicators.beaten || garIndicator === quoteLevelConstants.garIndicators.featured) {
      return true;
    }
    return false;
  }

  onSave = (mode) => {
    this.pensionSavings = null;
    if (mode && mode === 'ext') {
      this.extPensionForm.push(this.fb.group({
        textpensionProvider: ['', Validators.required],
        textplanNumber: [null, Validators.required],
        rbtnfundtransfertype: [null, Validators.required],
        rbtnfunddrawdown: [null, Validators.required],
        cncyfundValue: [null, Validators.required],
        rbtntaxfreeToggle: [null, Validators.required],
        sldrtaxfreeSlider: [null],
        cncyfundValueTaxfree: [null],
        adrsaddressline1: ['', Validators.required],
        adrsaddressline2: [''],
        adrsaddressline3: [null],
        adrsaddressline4: [null],
        postcode: ['', Validators.required],
        isActive: false,
        optionCode: null,
        providerReference: null
      }));
      if (this.accrdionListExt && this.accrdionListExt.length === 0) {
        this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Add another pension', pageID: this.getCurrentScreenURL() });
      } else if (this.accrdionListExt) {
        const accordnList = this.accrdionListExt[this.accrdionListExt.length - 1];

        let pensionIntroducer = accordnList.textpensionProvider ? accordnList.textpensionProvider.value : null;
        // let pensionIntroducer = accordnList.drdnpensionProvider.value;
        let fund = '';
        if (accordnList.cncyfundValue.value !== '') {
          fund = accordnList.cncyfundValue.value;
        }
        if (accordnList.cncyfundValueTaxfree.value !== '') {
          fund = accordnList.cncyfundValueTaxfree.value;
        }
        this.analyticsService.eventTrack({
          type: 'ButtonClick',
          name: 'Add another pension - confirm',
          pageID: this.getCurrentScreenURL()
          // pension: pensionIntroducer ? pensionIntroducer : '',
          // amount: fund ? fund : '' 
        });
      }
      this.createUserConfig(this.extPensionForm, 'ext', null, null);
    } else if (mode === 'dealpartner') {
      if (this.pensionForm.length < 1) {
        if (this.quoteFundInfo.cedingProvider === 'J') {
          this.pensionForm.push(this.fb.group({
            drdnpensionProvider: [null, Validators.required],
            textplanNumber: [(this.resPensionSavings && this.resPensionSavings.policyNo ?
              this.resPensionSavings.policyNo : null), Validators.required],
            rbtnfundtransfertype: [(this.resPensionSavings && this.resPensionSavings.fullFundInd ?
              this.resPensionSavings.fullFundInd : null), Validators.required],
            rbtnfunddrawdown: [(this.resPensionSavings && this.resPensionSavings.drawdownInd ? this.resPensionSavings.drawdownInd : null)],
            cncyfundValue: [null],
            rbtntaxfreeToggle: [null],
            sldrtaxfreeSlider: [null],
            cncyfundValueTaxfree: [null],
            adrsaddressline1: ['', Validators.required],
            adrsaddressline2: [''],
            adrsaddressline3: [null],
            adrsaddressline4: [null],
            postcode: ['', Validators.required],
            isActive: false,
            optionCode: null,
            providerReference: null,
            codeproductCode: [this.resPensionSavings.productCode, Validators.required],
          }));
          this.createUserConfig(this.pensionForm, null, null, null);
        } else if (this.legalAndGeneralProviderList && Object.keys(this.legalAndGeneralProviderList).length > 0) {
          this.pensionForm.push(this.fb.group({
            drdnpensionProvider: [this.legalAndGeneralProviderList['Name'], Validators.required],
            // textpensionProvider: ['', Validators.required],
            textplanNumber: [this.resPensionSavings.policyNo, Validators.required],
            rbtnfundtransfertype: [this.resPensionSavings.fullFundInd, Validators.required],
            rbtnfunddrawdown: [this.resPensionSavings.drawdownInd, Validators.required],
            cncyfundValue: [CurrencyFunctionalityService.convertNumberToCurrency(this.resPensionSavings.fundValue)],
            rbtntaxfreeToggle: [this.resPensionSavings.taxfreeSelected],
            sldrtaxfreeSlider: [this.resPensionSavings.tfcPct],
            cncyfundValueTaxfree: [CurrencyFunctionalityService.convertNumberToCurrency(this.resPensionSavings.tfcAmt)],
            adrsaddressline1: [this.legalAndGeneralProviderList['Address 1'], Validators.required],
            adrsaddressline2: [this.legalAndGeneralProviderList['Address 2']],
            adrsaddressline3: [this.legalAndGeneralProviderList['Address 3']],
            adrsaddressline4: [this.legalAndGeneralProviderList['Address 4']],
            postcode: [this.legalAndGeneralProviderList['Post Code'], Validators.required],
            isActive: false,
            optionCode: this.resPensionSavings.optionCode,
            providerReference: this.resPensionSavings.providerReference
          }));
        } else {
          this.pensionForm.push(this.fb.group({
            drdnpensionProvider: [null, Validators.required],
            textplanNumber: [(this.resPensionSavings && this.resPensionSavings.policyNo ?
              this.resPensionSavings.policyNo : null), Validators.required],
            rbtnfundtransfertype: [(this.resPensionSavings && this.resPensionSavings.fullFundInd ?
              this.resPensionSavings.fullFundInd : null), Validators.required],
            rbtnfunddrawdown: [(this.resPensionSavings && this.resPensionSavings.drawdownInd ? this.resPensionSavings.drawdownInd : null)],
            cncyfundValue: [null],
            rbtntaxfreeToggle: [null],
            sldrtaxfreeSlider: [null],
            cncyfundValueTaxfree: [null],
            adrsaddressline1: ['', Validators.required],
            adrsaddressline2: [''],
            adrsaddressline3: [null],
            adrsaddressline4: [null],
            postcode: ['', Validators.required],
            isActive: false,
            optionCode: null,
            providerReference: null
          }));
        }
        this.createUserConfig(this.pensionForm, null, null, null);
      }
    } else {
      if (this.quoteFundInfo.cedingProvider === 'J') {
        this.pensionForm.push(this.fb.group({
          drdnpensionProvider: [null, Validators.required],
          // textpensionProvider: ['', Validators.required],
          textplanNumber: [null, Validators.required],
          codeproductCode: [null, Validators.required],
          rbtnfundtransfertype: [null, Validators.required],
          rbtnfunddrawdown: [null, Validators.required],
          cncyfundValue: [null, Validators.required],
          rbtntaxfreeToggle: [null, Validators.required],
          sldrtaxfreeSlider: [null],
          cncyfundValueTaxfree: [null],
          adrsaddressline1: ['', Validators.required],
          adrsaddressline2: [''],
          adrsaddressline3: [null],
          adrsaddressline4: [null],
          postcode: ['', Validators.required],
          isActive: false,
          optionCode: null,
          providerReference: null
        }));
      } else {
        this.pensionForm.push(this.fb.group({
          drdnpensionProvider: [null, Validators.required],
          // textpensionProvider: ['', Validators.required],
          textplanNumber: [null, Validators.required],
          rbtnfundtransfertype: [null, Validators.required],
          rbtnfunddrawdown: [null, Validators.required],
          cncyfundValue: [null, Validators.required],
          rbtntaxfreeToggle: [null, Validators.required],
          sldrtaxfreeSlider: [null],
          cncyfundValueTaxfree: [null],
          adrsaddressline1: ['', Validators.required],
          adrsaddressline2: [''],
          adrsaddressline3: [null],
          adrsaddressline4: [null],
          postcode: ['', Validators.required],
          isActive: false,
          optionCode: null,
          providerReference: null
        }));
      }

      if (this.accrdionList && this.accrdionList.length === 0) {
        this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Add another pension', pageID: this.getCurrentScreenURL() });
      } else if (this.accrdionList) {
        const accordnList = this.accrdionList[this.accrdionList.length - 1];

        let pensionIntroducer = accordnList.drdnpensionProvider.value;
        let fund = '';
        if (accordnList.cncyfundValue.value !== '') {
          fund = accordnList.cncyfundValue.value;
        }
        if (accordnList.cncyfundValueTaxfree.value !== '') {
          fund = accordnList.cncyfundValueTaxfree.value;
        }
        this.analyticsService.eventTrack({
          type: 'ButtonClick',
          name: 'Add another pension - confirm',
          pageID: this.getCurrentScreenURL()
          // pension: pensionIntroducer ? pensionIntroducer : '',
          // amount: fund ? fund : ''
        });
      }
      this.createUserConfig(this.pensionForm, null, null, null);
    }

  }
  createUserConfig = (pensionForm, mode?: string, pensionStore?: StoreModel.PensionSavings,
    pensionStoreIndex?: number) => {
    const index = pensionForm.value.length - 1;
    const pension = pensionForm.value[index];
    const controls = Object.keys(pension);
    const obj = {};
    const form = pensionForm.controls[index] as FormArray;
    controls.forEach((control) => {
      const controlType = control.slice(0, 4);
      let value = {};
      switch (controlType) {
        case 'text':
          value = {
            type: 'textbox',
            value: '',
            name: control,
            label: '',
            readonly: false,
            maxlength: control === 'textpensionProvider' ? this.userInputDetail.pensionProviderConfig.maxlength : 'textpensionProvider' ? 16 : 50,
            controlName: control,
            borderRequired: false,
            required: true,
            placeHolder: 'Please enter',
            errorMessage: control === 'textpensionProvider' ?
              this.userInputDetail.pensionProviderConfig.errorMessage : this.userInputDetail.planNumberConfig.errorMessage,
            invalidErrorMessage: control === 'textpensionProvider' ?
              this.userInputDetail.pensionProviderConfig.invalidErrorMessage : this.userInputDetail.planNumberConfig.invalidErrorMessage,
            keyCol: {
              md: 12,
              sm: 12,
              xs: 12
            },
            valCol: {
              md: 10,
              sm: 12,
              xs: 12
            }
          };
          if (control === 'textpensionProvider' && this.pensionSavings) {
            value['value'] = form.get('textpensionProvider').value;
          }
          break;
        case 'rbtn':
          if (control === 'rbtnfundtransfertype') {
            value = this.userInputDetail.radioButtonFundtransferType;
          } else if (control === 'rbtnfunddrawdown') {
            /* Defect# 3341 - Info icon required for drawdown question on 'Your pension savings' page */
            value = (mode === 'ext') ? this.userInputDetail.radioButtonFunddrawdownExt
              : this.userInputDetail.radioButtonFunddrawdown;
          } else if (control === 'rbtntaxfreeToggle') {
            value = this.userInputDetail.radioButtontaxfreeCashConfig;
          }
          break;
        case 'cncy':
          if (control === 'cncyfundValue') {
            value = this.userInputDetail.fundValueConfig;
            value['value'] = '';
            if (this.pensionSavings) {
              value['value'] = form.get('cncyfundValue').value;
            }
          } else if (control === 'cncyfundValueTaxfree') {
            value = this.userInputDetail.taxfreeValueConfig;
            value['value'] = '';
            value['titleValue'] = '';
            if (this.pensionSavings) {
              if ((this.pensionSavings[pensionStoreIndex]['isCeding']) || (this.pensionSavings[pensionStoreIndex]['tfcPct'])) {
                value['titleValue'] = parseFloat(this.pensionSavings[pensionStoreIndex]['tfcPct']).toFixed(2);
                value['value'] = this.pensionSavings[pensionStoreIndex]['tfcAmt'];
              } else {
                value['titleValue'] = parseFloat(Number(this.pensionSavings[pensionStoreIndex]['extTfcPct']).toString()).toFixed(2);
                value['value'] = this.pensionSavings[pensionStoreIndex]['extTfcAmt'];
              }
            }
          }
          break;
        case 'sldr':
          if (control === 'sldrtaxfreeSlider') {
            value = this.userInputDetail.sliderTaxfreeLumpsumConfig;
            value['currentValue'] = 0;
            if (this.pensionSavings) {
              if ((this.pensionSavings[pensionStoreIndex]['isCeding']) || (this.pensionSavings[pensionStoreIndex]['tfcPct'])) {
                value['currentValue'] = this.pensionSavings[pensionStoreIndex]['tfcPct'];
              } else {
                value['currentValue'] = this.pensionSavings[pensionStoreIndex]['extTfcPct'];
              }
            }
            //add condition for PTFC
            if (this.responseApplicationData.ptfc) {
              // value['currentValue'] = '';
            }

          }
          break;
        case 'adrs':
          const addressLine1Config = JSON.parse(JSON.stringify(this.userInputDetail.addressLine1Config));
          const strIndex = control.substring(control.length - 1);
          addressLine1Config.name = control;
          addressLine1Config.maxlength = 35
          addressLine1Config.controlName = control;
          addressLine1Config.label = 'Address line ' + strIndex;
          addressLine1Config.errorMessage = 'Please enter an address line' + strIndex + ' value';
          // removed strIndex == '2' as part of defect 2806 - only Address line1 should be mandatory
          addressLine1Config.required = (strIndex === '1') ? true : false;
          if (this.pensionSavings) {
            addressLine1Config.value = form.get('adrsaddressline' + strIndex).value;
          }
          value = addressLine1Config;
          break;
        case 'post':
          value = this.userInputDetail.postCodeConfig;
          value['defaultValue'] = ''
          if (this.pensionSavings) {
            value['defaultValue'] = form.get('postcode').value.trim();
          }
          break;
        case 'code':
          value = this.userInputDetail.productCodeDDLConfig;
          if (this.quoteFundInfo && this.quoteFundInfo.productcode.length >= 1) {
            const arrOptions = [];
            this.quoteFundInfo.productcode.forEach(result => {
              arrOptions.push(
                { value: result, code: result }
              );
            });
            if (this.quoteFundInfo.productcode && this.quoteFundInfo.productcode.length === 1) {
              value['defaultValue'] = this.quoteFundInfo.productcode[0];
              this.userInputDetail.productCodeDDLConfig.defaultValue = this.quoteFundInfo.productcode[0];
              form.get('codeproductCode').setValue(this.quoteFundInfo.productcode[0]);
              this.selectedProductCode = true;
            }
            if (this.pensionSavings) {
              value['defaultValue'] = form.get('codeproductCode').value;
              form.get('codeproductCode').setValue(form.get('codeproductCode').value);
            }
            //form.get('codeproductCode').setValue('aaaaa')
            value['options'] = arrOptions;
            value['name'] = control;
            value['controlName'] = control;
            value['label'] = 'Product Code';
            obj[control] = { ...value };
          }
          break;
        case 'drdn':
          value = this.userInputDetail.pensionProviderDDLConfig;
          value['value'] = '';
          const cedingProvider = this.gettingCedingProvider();
          this.quoteDatacaptureService.searchPensionProviderByIntro(cedingProvider)
            .subscribe((results: any[]) => {
              this.resultAddress = results;
              if (results !== undefined && results.length >= 1) {
                // value['options'] = this.resultAddress.map(r => r.Name);
                const arrOptions = [];
                results.forEach(result => {
                  arrOptions.push(
                    { value: result.Name, code: result.Ref }
                  );
                });
                value['options'] = arrOptions;
                if (this.pensionSavings || this.isMaturityQuote) {
                  value['value'] = this.isMaturityQuote ? this.legalAndGeneralProviderList['Name'] : pensionStore.pensionProvider;
                  const drpValue = results.filter(address => address.Name === (this.isMaturityQuote ? this.legalAndGeneralProviderList['Name'] : pensionStore.pensionProvider));
                  form.get('drdnpensionProvider').setValue(drpValue.length > 0 ? drpValue[0].Ref : null);
                  // pensionForm.setValue(drpValue[0].code);
                  // obj['optionCode'] = drpValue[0]['Options Code'];
                  // obj['providerReference'] = drpValue[0]['Ref'];
                  obj['optionCode'] = drpValue[0] ? drpValue[0]['Options Code'] || null : null;
                  obj['providerReference'] = drpValue[0] ? drpValue[0]['Ref'] || null : null;
                }
              }
              value['name'] = control;
              value['controlName'] = control;
              value['label'] = 'Pension provider';
              obj[control] = { ...value };
              if (this.pensionSavings) {
                obj['addressSeachEnabled'] = false;
              } else {
                obj['addressSeachEnabled'] = true;
              }
              this.accrdionList.map(a => a.isActive = false);
              obj['isActive'] = true;
              this.accrdionList.push(obj);
              this.noPensionAdded = false;
              if (this.pensionSavings) {
                this.formatTaxfree(index);
                this.currencyChangeHandler(form.get('cncyfundValue').value, index);
              }
            });
          break;

        default:
          break;
      }
      if (control === 'optionCode' || control === 'providerReference') {
        obj[control] = null;
      } else {
        obj[control] = { ...value };
      }
    });
    // });
    if (this.pensionSavings) {
      obj['addressSeachEnabled'] = false;
      obj['optionCode'] = pension.optionCode;
      obj['providerReference'] = pension.providerReference;
    } else {
      obj['addressSeachEnabled'] = true;
    }
    if (mode && mode === 'ext') {
      this.accrdionListExt.map(a => a.isActive = false);
      obj['isActive'] = true;
      this.accrdionListExt.push(obj);
      this.noExtPensionAdded = false;
      if (this.pensionSavings) {
        this.formatTaxfree(index, 'ext');
        this.currencyChangeHandler(form.get('cncyfundValue').value, index, 'ext');
      }
    }
    // else {
    //   this.accrdionList.push(obj);
    // }
  }
  formatCurrency = (amount): string => {
    if (amount) {
      amount = '£' + CurrencyFunctionalityService.number_format(amount, 2);
    }
    return amount;
  }
  formatTaxfree = (index, mode?: string) => {
    let taxFreeAmount = '0.00';
    if (mode && mode === 'ext') {
      // tslint:disable-next-line:no-string-literal
      const rbtntaxfreeToggle = this.extPensionForm.controls[index].get('rbtntaxfreeToggle').value;
      switch (rbtntaxfreeToggle) {
        case 'P':
          taxFreeAmount = CurrencyFunctionalityService.number_format(String((CurrencyFunctionalityService.convertCurrencyToNumber(
            this.accrdionListExt[index].cncyfundValue.value) * this.accrdionListExt[index].sldrtaxfreeSlider.currentValue) / 100), 2);
          break;
        case 'C':
          // tslint:disable-next-line:max-line-length
          taxFreeAmount = this.accrdionListExt[index].cncyfundValueTaxfree.value ?
            CurrencyFunctionalityService.number_format(this.accrdionListExt[index].cncyfundValueTaxfree.value, 2) :
            '0.00';
          break;
        default:
          break;
      }
    } else if (mode && mode === 'dealpartner') {
      const tfcIndicator = this.resultQuote['taxFreeCashAmountPercent'];
      if (tfcIndicator === 'P' || tfcIndicator === 'A') {
        taxFreeAmount = CurrencyFunctionalityService.number_format(this.quoteFundInfo['totalTfc'], 2);
      }
    } else {
      // tslint:disable-next-line:no-string-literal
      const rbtntaxfreeToggle = this.pensionForm.controls[index].get('rbtntaxfreeToggle').value;
      switch (rbtntaxfreeToggle) {
        case 'P':
          taxFreeAmount = CurrencyFunctionalityService.number_format(String((CurrencyFunctionalityService.convertCurrencyToNumber(
            this.accrdionList[index].cncyfundValue.value) * this.accrdionList[index].sldrtaxfreeSlider.currentValue) / 100), 2);
          break;
        case 'C':
          // tslint:disable-next-line:max-line-length
          taxFreeAmount = this.accrdionList[index] && this.accrdionList[index].cncyfundValueTaxfree.value ?
            CurrencyFunctionalityService.number_format(this.accrdionList[index].cncyfundValueTaxfree.value, 2) :
            '0.00';
          break;
        default:
          break;
      }
    }
    return '£' + taxFreeAmount;
  }
  onManualClick(index, mode?: string) {
    if (mode && mode === 'ext') {
      this.accrdionListExt[index].addressSeachEnabled = !this.accrdionListExt[index].addressSeachEnabled;
    } else {
      this.accrdionList[index].addressSeachEnabled = !this.accrdionList[index].addressSeachEnabled;
    }
  }
  onAddressSeachClick(index, mode) {
    if (mode && mode === 'ext') {
      this.accrdionListExt[index].addressSeachEnabled = !this.accrdionListExt[index].addressSeachEnabled;
    } else {
      this.accrdionList[index].addressSeachEnabled = !this.accrdionList[index].addressSeachEnabled;
    }
  }
  onSelecteAddress(formattedAddress, index, mode?: string) {
    if (mode && mode === 'ext') {
      this.accrdionListExt[index].adrsaddressline1.value = formattedAddress[0]['addressLine1'];
      this.accrdionListExt[index].adrsaddressline2.value = formattedAddress[1]['addressLine2'];
      this.accrdionListExt[index].adrsaddressline3.value = formattedAddress[2]['addressLine3'];
      this.accrdionListExt[index].postcode.defaultValue = formattedAddress[5]['postalCode'].trim();
      this.accrdionListExt[index].adrsaddressline4.value = formattedAddress[3]['locality'];
      this.accrdionListExt[index].addressSeachEnabled = false;
      this.accrdionListExt[index].optionCode = formattedAddress['Options Code'] ? formattedAddress['Options Code'] : null;
      this.accrdionListExt[index].providerReference = formattedAddress['Ref'];
    } else {
      this.accrdionList[index].adrsaddressline1.value = formattedAddress[0]['addressLine1'];
      this.accrdionList[index].adrsaddressline2.value = formattedAddress[1]['addressLine2'];
      this.accrdionList[index].adrsaddressline3.value = formattedAddress[2]['addressLine3'];
      this.accrdionList[index].postcode.defaultValue = formattedAddress[5]['postalCode'].trim();
      this.accrdionList[index].adrsaddressline4.value = formattedAddress[3]['locality'];
      this.accrdionList[index].addressSeachEnabled = false;
      this.accrdionList[index].optionCode = formattedAddress['Options Code'] ? formattedAddress['Options Code'] : null;
      this.accrdionList[index].providerReference = formattedAddress['Ref'];
    }
  }
  onSelectedProvider(formattedAddress, index, mode?: string) {
    console.log('----', formattedAddress);
    if (mode && mode === 'ext') {
      this.accrdionListExt[index].adrsaddressline1.value = formattedAddress['Address 1'];
      this.accrdionListExt[index].adrsaddressline2.value = formattedAddress['Address 2'];
      this.accrdionListExt[index].adrsaddressline3.value = formattedAddress['Address 3'] ? formattedAddress['Address 3'] : '';
      this.accrdionListExt[index].postcode.defaultValue = formattedAddress['Post Code'].trim();
      //this.accrdionListExt[index].adrsaddressline4.value = '';
      this.accrdionListExt[index].adrsaddressline4.value = formattedAddress['Address 4'] ? formattedAddress['Address 4'] : '';
      this.accrdionListExt[index].addressSeachEnabled = false;
      this.accrdionListExt[index].optionCode = formattedAddress?.['Options Code'] ? formattedAddress['Options Code'] : null;
      this.accrdionListExt[index].providerReference = formattedAddress?.['Ref'];
    } else {
      this.accrdionList[index].adrsaddressline1.value = formattedAddress['Address 1'];
      this.accrdionList[index].adrsaddressline2.value = formattedAddress['Address 2'];
      this.accrdionList[index].adrsaddressline3.value = formattedAddress['Address 3'] ? formattedAddress['Address 3'] : '';
      this.accrdionList[index].postcode.defaultValue = formattedAddress['Post Code'].trim();
      //this.accrdionList[index].adrsaddressline4.value = '';
      this.accrdionListExt[index].adrsaddressline4.value = formattedAddress['Address 4'] ? formattedAddress['Address 4'] : '';
      this.accrdionList[index].addressSeachEnabled = false;
      this.accrdionList[index].optionCode = formattedAddress?.['Options Code'] ? formattedAddress['Options Code'] : null;
      this.accrdionList[index].providerReference = formattedAddress['Ref'];
    }
  }
  getTaxfreePerc = (pension) => {
    let taxfreePerc;
    switch (pension.rbtntaxfreeToggle) {
      case 'C':
        const fundValue = CurrencyFunctionalityService.convertCurrencyToNumber(
          pension.cncyfundValue);
        let val = CurrencyFunctionalityService.convertCurrencyToNumber(
          pension.cncyfundValueTaxfree);
        // val = parseFloat(val.replace(/,/g, ''));
        taxfreePerc = (val * 100) / fundValue;
        break;
      case 'P':
        taxfreePerc = pension.sldrtaxfreeSlider;
        break;
      default:
        taxfreePerc = 0;
        break;
    }
    return taxfreePerc;
  }
  ddlChange = (selectedAddress, index) => {
    selectedAddress = this.accrdionList[index].drdnpensionProvider.defaultValue;
    const formattedAddress = this.resultAddress.find(a => a.Ref === selectedAddress);
    this.accrdionList[index].drdnpensionProvider.value = formattedAddress ? formattedAddress.Name : null;
    if (formattedAddress) {
      this.accrdionList[index].adrsaddressline1.value = formattedAddress['Address 1'];
      this.accrdionList[index].adrsaddressline2.value = formattedAddress['Address 2'];
      this.accrdionList[index].adrsaddressline3.value = formattedAddress['Address 3'] ? formattedAddress['Address 3'] : '';
      this.accrdionList[index].postcode.defaultValue = formattedAddress['Post Code'].trim();
      this.accrdionList[index].adrsaddressline4.value = '';
      this.accrdionList[index].addressSeachEnabled = false;
      this.accrdionList[index].optionCode = formattedAddress['Options Code'];
      this.accrdionList[index].providerReference = formattedAddress['Ref'];
    }

  }
  ddlChangeProductCode(selectedProductCode, index) {

  }
  gettingCedingProvider = (): string => {
    let cedingProvider = null;
    const provider = this.quoteFundInfo.cedingProvider;
    switch (provider) {
      case 'I':
        cedingProvider = 'L&G';
        break;
      case 'H':
        cedingProvider = 'Aegon';
        break;
      case 'F':
        cedingProvider = 'Sun Life';
        break;
      case 'J':
        cedingProvider = 'Reassure';
        break;
      case 'K':
        cedingProvider = 'Prudential';
        break;
      case 'O':
        cedingProvider = 'Phoenix';
        break;
    }
    return cedingProvider;
  }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {

    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourPensionSavingsApply;
    /* this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) { */
    /** In the line below we are over-writing the contentData object values with CMSData object values */
    /* this.contentData.yourPensionSavings.mainHeader = this.CMSData.string_PensionSaveAppTitle;
    this.contentData.yourPensionSavings.subHeader = this.CMSData.string_PensionSaveAppSubtitle1;
    this.contentData.yourPensionSavings.headerExternal = this.CMSData.string_PensionSaveAppSubtitle4;
    this.contentData.yourPensionSavings.mainHeaderExternal = this.CMSData.string_PensionSaveAppSubtitle5;
    this.contentData.yourPensionSavings.tfcIncludedMessage1 = this.CMSData.string_TfcIncludedComparisionProviderMessage1;
    this.contentData.yourPensionSavings.tfcIncludedMessage2 = this.CMSData.string_TfcIncludedComparisionProviderMessage2;
    this.contentData.yourPensionSavings.tfcNotIncludedMessage1 = this.CMSData.string_TfcNotIncludedComparisionProviderMessage1;
    this.contentData.yourPensionSavings.tfcNotIncludedMessage2 = this.CMSData.string_TfcNotIncludedComparisionProviderMessage2;
    this.contentData.yourPensionSavings.extTfcIncludedMessage = this.CMSData.string_TfcIncludedComparisionMessage;
    this.contentData.yourPensionSavings.extTfcNotIncludedMessage = this.CMSData.string_TfcNotIncludedComparisionMessage;
    this.userInputDetail.radioButtonFundtransferType.inValidTransferType = this.CMSData.string_PensionSaveAppProviderError1;
    // this.userInputDetail.radioButtonFundtransferType.validationMsg = this.CMSData.string_PensionSaveAppProviderError1;
    this.userInputDetail.radioButtontaxfreeCashConfig.invalidTaxfree = this.CMSData.string_PensionSaveAppTFCError;
    this.userInputDetail.radioButtonFunddrawdown.validationMsg = this.CMSData.string_PensionSaveAppProviderError1;
    this.contentData.yourPensionSavings.DrawdownWarningMessage = this.CMSData.string_PensionSaveDrawdownMessage;
    this.userInputDetail.pensionProviderConfig.errorMessage = this.CMSData.string_PensionSaveAppPlanNoError;
    this.userInputDetail.pensionProviderConfig.invalidErrorMessage = this.CMSData.string_ProviderFormatError;
    this.userInputDetail.pensionProviderDDLConfig.errorMessage = this.CMSData.string_PensionSaveAppPlanNoError;
    this.contentData.yourPensionSavings.dealPartnerHeader = this.CMSData.html_PensionSaveAppSubtitle6_1
      + ' ' + ((this.introProvider && this.introProvider.length > 0) ? this.introProvider[0].value + ' ' : '')
      + this.CMSData.html_PensionSaveAppSubtitle6_2;
    this.contentData.yourPensionSavings.descriptionGI = this.CMSData.string_PensionSaveAppSubtitle2A;
    this.contentData.yourPensionSavings.descriptionLTA = this.CMSData.string_PensionSaveAppSubtitle2;
    this.contentData.yourPensionSavings.subHeaderTFC = this.CMSData.string_PensionSaveAppSubtitle7
      + ' ' + ((this.introProvider && this.introProvider.length > 0) ? this.introProvider[0].value : '');
    this.contentData.yourPensionSavings.subHeaderExternal = this.CMSData.string_PensionSaveAppProviderError;
    this.contentData.yourPensionSavings.addPensionCTA = this.CMSData.string_AddPensionCTALabel;
    this.contentData.yourPensionSavings.yourPensionsTotal = this.CMSData.string_PensionSaveAppSubtitle10;
    this.contentData.yourPensionSavings.taxfreeTotal = this.CMSData.string_PensionSaveAppSubtitle11;
    if (this.quoteFundInfo && this.quoteFundInfo.productType === 'C') {
      this.contentData.yourPensionSavings.fundTotal = this.CMSData.string_PensionSaveAppSubtitle12;
    } else if (this.quoteFundInfo && (this.quoteFundInfo.productType === 'G' || this.quoteFundInfo.productType === 'H')) {
      this.contentData.yourPensionSavings.fundTotal = this.CMSData.string_PensionSaveAppSubtitle13;
    }
    this.userInputDetail.postCodeConfig.errorMessage = this.CMSData.commonBlock.string_PostcodeErrorMessageWording;
    this.userInputDetail.planNumberConfig.errorMessage = this.CMSData.string_PensionSaveAppProviderError2;
    this.userInputDetail.planNumberExtConfig.errorMessage = this.CMSData.string_PensionSaveAppProviderError2;
    this.userInputDetail.planNumberConfig.invalidErrorMessage = this.CMSData.string_PlanFormatError;
    this.userInputDetail.planNumberExtConfig.invalidErrorMessage = this.CMSData.string_PlanFormatError;
    this.userInputDetail.fundValueConfig.errorMessage = this.CMSData.string_EnterAmountErrorMessageWording;
    this.userInputDetail.radioButtonFunddrawdown.infoIconData.content = this.CMSData.string_DrawdownInformationText;
    this.userInputDetail.radioButtonFunddrawdownExt.infoIconData.content = this.CMSData.string_DrawdownInformationText;
    this.userInputDetail.sliderTaxfreeLumpsumConfig.infoIconData.content = this.CMSData.string_TFCInfoPoint;
    this.userInputDetail.sliderTaxfreeLumpsumExtConfig.infoIconData.content = this.CMSData.string_TFCInfoPoint;
    this.userInputDetail.radioButtontaxfreeCashConfig.infoIconData.content =
      (this.resultQuote && this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes) ? this.CMSData.string_TFCInfoPointGMP
        : this.CMSData.string_TFCInfoPoint;
  }
  this.initiliseForm();
}); */

    /* const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourPensionSavingsApply;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res; */
    if (this.CMSData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentData.yourPensionSavings.mainHeader = this.isMaturityQuote ? this.CMSData.string_YourMaturityValue : this.CMSData.string_PensionSaveAppTitle;
      this.contentData.yourPensionSavings.subHeader = this.isMaturityQuote ? this.CMSData.string_MaturityValueCopy : this.CMSData.string_PensionSaveAppSubtitle1;
      this.contentData.yourPensionSavings.headerExternal = this.CMSData.string_PensionSaveAppSubtitle4;
      this.contentData.yourPensionSavings.mainHeaderExternal = this.CMSData.string_PensionSaveAppSubtitle5;
      this.contentData.yourPensionSavings.tfcIncludedMessage1 = this.CMSData.string_TfcIncludedComparisionProviderMessage1;
      this.contentData.yourPensionSavings.tfcIncludedMessage2 = this.CMSData.string_TfcIncludedComparisionProviderMessage2;
      this.contentData.yourPensionSavings.tfcNotIncludedMessage1 = this.CMSData.string_TfcNotIncludedComparisionProviderMessage1;
      this.contentData.yourPensionSavings.tfcNotIncludedMessage2 = this.CMSData.string_TfcNotIncludedComparisionProviderMessage2;
      this.contentData.yourPensionSavings.extTfcIncludedMessage = this.CMSData.string_TfcIncludedComparisionMessage;
      this.contentData.yourPensionSavings.extTfcNotIncludedMessage = this.CMSData.string_TfcNotIncludedComparisionMessage;
      this.contentData.yourPensionSavings.ptfcTaxFreeCashMessage = "Your previously added a tax-free cash amount to your quote, are you sure you don't want to take any? If you do, you can add it this as % or £ here";
      this.userInputDetail.radioButtonFundtransferType.inValidTransferType = this.CMSData.string_PensionSaveAppProviderError1;
      // this.userInputDetail.radioButtonFundtransferType.validationMsg = this.CMSData.string_PensionSaveAppProviderError1;
      this.userInputDetail.radioButtontaxfreeCashConfig.invalidTaxfree = this.CMSData.string_PensionSaveAppTFCError;
      this.userInputDetail.radioButtonFunddrawdown.validationMsg = this.CMSData.string_PensionSaveAppProviderError1;
      this.contentData.yourPensionSavings.DrawdownWarningMessage = this.isMaturityQuote ? this.CMSData.string_PensionSaveDrawdownMessage2 : this.CMSData.string_PensionSaveDrawdownMessage;
      this.userInputDetail.pensionProviderConfig.errorMessage = this.CMSData.string_PensionSaveAppPlanNoError;
      this.userInputDetail.pensionProviderConfig.invalidErrorMessage = this.CMSData.string_ProviderFormatError;
      this.userInputDetail.pensionProviderDDLConfig.errorMessage = this.CMSData.string_PensionSaveAppPlanNoError;
      this.contentData.yourPensionSavings.dealPartnerHeader = this.CMSData.html_PensionSaveAppSubtitle6_1
        + ' ' + ((this.introProvider && this.introProvider.length > 0) ? this.introProvider[0].value + ' ' : '')
        + this.CMSData.html_PensionSaveAppSubtitle6_2;
      this.contentData.yourPensionSavings.descriptionGI = this.isMaturityQuote ? this.CMSData['string_PensionSaveAppSubtitle(GI)'] : this.CMSData.string_PensionSaveAppSubtitle2A;
      this.contentData.yourPensionSavings.descriptionLTA = this.isMaturityQuote ? this.CMSData['string_PensionSaveSubtitle(LTA)'] : this.CMSData.string_PensionSaveAppSubtitle2;
      this.contentData.yourPensionSavings.subHeaderTFC = this.CMSData.string_PensionSaveAppSubtitle7
        + ' ' + ((this.introProvider && this.introProvider.length > 0) ? this.introProvider[0].value : '');
      this.contentData.yourPensionSavings.subHeaderExternal = this.CMSData.string_PensionSaveAppProviderError;
      this.contentData.yourPensionSavings.addPensionCTA = this.CMSData.string_AddPensionCTALabel;
      this.contentData.yourPensionSavings.yourPensionsTotal = this.CMSData.string_PensionSaveAppSubtitle10;
      this.contentData.yourPensionSavings.taxfreeTotal = this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes ||
        this.isGARProduct(this.resultQuote['garIndicator']) ? this.CMSData.string_PensionSaveAppSubtitle11GMP : this.CMSData.string_PensionSaveAppSubtitle11;
      if (this.isMaturityQuote) {
        this.contentData.yourPensionSavings.fundTotal = this.contentData.yourPensionSavings.maturityValueFundTotal;
        this.userInputDetail.radioButtonFundtransferType.questionStatement = this.CMSData.string_MatLumpSumApplication;
        this.userInputDetail.radioButtonFundtransferType.questionOptions = [
          {
            label: 'Yes',
            code: 'F'
          },
          {
            label: 'No',
            code: 'P'
          }
        ];
      } else {
        if (this.quoteFundInfo && this.quoteFundInfo.productType === 'C') {
          this.contentData.yourPensionSavings.fundTotal = this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes ||
            this.isGARProduct(this.resultQuote['garIndicator']) ? this.CMSData.string_PensionSaveAppSubtitle12GMP : this.CMSData.string_PensionSaveAppSubtitle12;
        } else if (this.quoteFundInfo && (this.quoteFundInfo.productType === 'G' || this.quoteFundInfo.productType === 'H')) {
          this.contentData.yourPensionSavings.fundTotal = this.CMSData.string_PensionSaveAppSubtitle13;
        }
      }
      this.userInputDetail.postCodeConfig.errorMessage = this.CMSData.commonBlock.string_PostcodeErrorMessageWording;
      this.userInputDetail.planNumberConfig.errorMessage = this.CMSData.string_PensionSaveAppProviderError2;
      this.userInputDetail.planNumberExtConfig.errorMessage = this.CMSData.string_PensionSaveAppProviderError2;
      this.userInputDetail.planNumberConfig.invalidErrorMessage = this.CMSData.string_PlanFormatError;
      this.userInputDetail.planNumberExtConfig.invalidErrorMessage = this.CMSData.string_PlanFormatError;
      this.userInputDetail.fundValueConfig.errorMessage = this.CMSData.string_EnterAmountErrorMessageWording;
      this.userInputDetail.radioButtonFunddrawdown.infoIconData.content = this.CMSData.string_DrawdownInformationText;
      this.userInputDetail.radioButtonFunddrawdownExt.infoIconData.content = this.CMSData.string_DrawdownInformationText;
      this.userInputDetail.sliderTaxfreeLumpsumConfig.infoIconData.content = this.CMSData.string_TFCInfoPoint;
      this.userInputDetail.sliderTaxfreeLumpsumExtConfig.infoIconData.content = this.CMSData.string_TFCInfoPoint;

      if (this.responseApplicationData['businessType'] === 'OMO' && this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes) {
        this.userInputDetail.radioButtontaxfreeCashConfig.infoIconData.content = this.CMSData.string_TFCInfoPointGMP + '<br/><br/>' + this.CMSData.string_TFCInfoPointGMPText2
      }
      else if (this.responseApplicationData['businessType'] === 'OMO' && this.quoteFundInfo && this.quoteFundInfo.productType === 'C') {
        this.userInputDetail.radioButtontaxfreeCashConfig.infoIconData.content = this.CMSData.string_TFCInfoPoint_OMO_Text1 + '<br/><br/>' + this.CMSData.string_TFCInfoPoint_OMO_Text2;

      } else {
        this.userInputDetail.radioButtontaxfreeCashConfig.infoIconData.content = this.CMSData.string_TFCInfoPoint_IVPP_Text1 + '<br/><br/>' + this.CMSData.string_TFCInfoPoint_IVPP_Text2 + '<br/><br/>' + this.CMSData.string_TFCInfoPoint_IVPP_Text3;
        this.userInputDetail.sliderTaxfreeLumpsumExtConfig.infoIconData.content = this.CMSData.string_TFCInfoPoint_IVPP_Text1 + '<br/><br/>' + this.CMSData.string_TFCInfoPoint_IVPP_Text2 + '<br/><br/>' + this.CMSData.string_TFCInfoPoint_IVPP_Text3;
      }
    }
    // });

    // this.quoteDatacaptureService.searchPensionProviderByIntro('N').subscribe(res=> {
    //   this.externalProvidersList = res;
    this.initiliseForm();
    // });
  }
  /** For web tracking */
  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
    return this.screenName;
  }

  displayTooltipMessage(data: any) {
    // console.log("tooltip method called");
    // console.log(JSON.stringify(data))
    // console.log('this.userInputDetail.radioButtonFunddrawdown.infoIconData.content', this.userInputDetail.radioButtonFunddrawdown.infoIconData.content)
    if (data == 'rbtntaxfreeToggle') {
      this.tooltipModal.content = this.userInputDetail.radioButtontaxfreeCashConfig.infoIconData.content;
      this.displayTooltipAlert = true;

    } else {
      this.tooltipModal.content = this.userInputDetail.radioButtonFunddrawdown.infoIconData.content;
      this.displayTooltipAlert = true;
    }

  }

  closeModal() {
    this.displayTooltipAlert = false;
  }

  triggerWADelete(mode, accrdnList) {
    let pensionIntroducer = '';
    if (mode && mode === 'ext') {
      pensionIntroducer = accrdnList.textpensionProvider ? accrdnList.textpensionProvider.value : null;
      this.showWarningExternal = false;
    } else {
      pensionIntroducer = accrdnList.drdnpensionProvider.value;
      this.showWarningDealPartner = false;
    }
    let pensionInt
    let fund = '';
    if (accrdnList.cncyfundValue.value !== '') {
      fund = accrdnList.cncyfundValue.value;
    }
    if (accrdnList.cncyfundValueTaxfree.value !== '') {
      fund = accrdnList.cncyfundValueTaxfree.value;
    }
    this.analyticsService.eventTrack({
      type: 'ButtonClick',
      name: 'Delete pension source',
      pageID: this.getCurrentScreenURL()
      // pension: pensionIntroducer ? pensionIntroducer : '',
      // amount: fund ? fund : ''
    });

  }
  policyNoEventEmitter(val, index, mode?: string) {
    if (mode && mode === 'ext') {
      this.accrdionListExt[index].textplanNumber.value = val;
    } else {
      this.accrdionList[index].textplanNumber.value = val;
    }
  }
  checkIfCedingProvider() {
    //cedingProvider
    if (!this.checkIfObjEmpty(this.quoteFundInfo) &&
      !this.quoteDatacaptureService.checkIfValueIsEmpty(this.quoteFundInfo['cedingProvider'])
      && (this.checkIfCedingProviderMatches(this.quoteFundInfo['cedingProvider']))) {
      return true;
    }
    return false;
  }
  checkIfObjEmpty(obj) {
    if (!this.quoteDatacaptureService.checkIfValueIsEmpty(obj) && Object.keys(obj).length > 0) {
      return false;
    } return true;
  }
  checkIfCedingProviderMatches(cedingProvider: string) {
    if (cedingProvider === 'I' || cedingProvider === 'H' || cedingProvider === 'F' || cedingProvider === 'O' ||
      cedingProvider === 'J' || cedingProvider === 'K') {
      return true;
    }
    return false;
  }


  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }
}
